"use client"

import { ApertureStyles, T, MAXW, SectionEyebrow, Check } from "./_shared"

export default function ApertureSecurity() {
  // Stated claims are kept conservative — anything we can't enforce in
  // code right now is framed in terms of the actual current behavior.
  // No SOC 2 cert claim until we're certified; no "per-tenant keys"
  // until the encryption story is rebuilt.
  const pillars = [
    { t: "DPA available",  d: "Privacy, DPA, and deletion terms are published. For legal or vendor-review questions, email support@databridge.so." },
    { t: "Encrypted storage", d: "Uploads move over HTTPS and are stored with provider-managed encryption at rest through Supabase." },
    { t: "No resale or training",  d: "Uploaded lists are used to clean your dataset. We do not sell lists or train models on your contacts." },
    { t: "Per-row audit trail",    d: "Every flagged row includes the rule that caught it, so the export is easier to defend internally." },
  ]
  return (
    <section id="security" className="relative scroll-mt-24" style={{ background: T.bgSoft }}>
      <ApertureStyles />
      <div className={`${MAXW} mx-auto px-6 lg:px-10 py-12 sm:py-16 md:py-24`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <SectionEyebrow>Trust</SectionEyebrow>
            <h2
              className="mt-3 leading-[1.0] tracking-[-0.035em]"
              style={{ fontSize: "clamp(2rem, 4vw, 3.1rem)", fontWeight: 800 }}
            >
              Built for lists you{" "}
              <em style={{ color: T.acc, fontStyle: "italic", fontWeight: 700 }}>can&rsquo;t afford to leak.</em>
            </h2>
            <p className="mt-5 max-w-[48ch]" style={{ fontSize: 15.5, color: T.ink2, lineHeight: 1.6 }}>
              Email lists are sensitive. DataBridge keeps the trust story boring:
              encrypted storage, published legal terms, no model training on your
              contacts, and a row-level audit trail. Read the{" "}
              <a href="/privacy" className="font-semibold" style={{ color: T.acc }}>privacy policy</a>{" "}
              if you want the receipts.
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {pillars.map((p) => (
              <div
                key={p.t}
                className="p-5 rounded-xl apl-card-hover"
                style={{
                  background: T.surface,
                  border: `1px solid ${T.hair}`,
                  boxShadow: `0 1px 0 rgba(255,255,255,0.6) inset`,
                }}
              >
                <div className="flex items-center gap-2.5">
                  <span
                    className="inline-flex items-center justify-center"
                    style={{
                      width: 28, height: 28, borderRadius: 8,
                      background: T.accChip,
                      border: `1px solid rgba(15,81,50,0.25)`,
                      color: T.acc,
                    }}
                  >
                    <Check />
                  </span>
                  <h3 style={{ fontSize: 14.5, fontWeight: 700, letterSpacing: "-0.01em" }}>{p.t}</h3>
                </div>
                <p className="mt-3" style={{ fontSize: 13, color: T.ink2, lineHeight: 1.55 }}>{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
